import firebaseInstance from "../../../util/firebase";
import firebase from "firebase";
import axios from "axios";
import _ from "lodash";
import router from "@/router"

export default {
  logout: (state, item) => {
    state.commit("CLEAR_STATE", {});
    firebaseInstance
      .auth()
      .signOut()
      .then(
        () => {
          console.log("signed out...");
        },
        error => {
          console.log("Error when logging out", error);
        }
      );
  },
  googleLogin: (state, item) => {
    var provider = new firebase.auth.GoogleAuthProvider();
    provider.setCustomParameters({ prompt: "select_account" });
    firebaseInstance
      .auth()
      .signInWithPopup(provider)
      .then(result => {
        var user = result.user;
        firebaseInstance
          .database()
          .ref("users/" + user.uid)
          .once("value", snap => {
            var data = snap.val();
            if (data) {
              state.commit("CLEAR_AUTH_ERROR", {});
              router.push("/explore");
              state.commit("SET_LOGGED_IN", true);
              state.commit("SET_LOGGED_IN_LOADING", false);
            } else {
              var key = Math.ceil(Math.random() * 1000000000);
              var companyKey = "";
              var chars =
                "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
              for (var i = 32; i > 0; --i) {
                companyKey += chars[Math.floor(Math.random() * chars.length)];
              }
              var object = {
                fullName: user.displayName,
                email: user.email,
                emailVerified: user.emailVerified,
                verificationKey: key,
                url: window.location.origin,
                company: "My Company",
                myCompany: companyKey
              };
              firebaseInstance
                .database()
                .ref("users/" + user.uid)
                .set(object, () => {
                  console.log("saved user data");
                  state.commit("SAVE_USER_DATA", object);
                  if (state.getters.redirectUrl) {
                    router.push(state.getters.redirectUrl);
                    state.commit("SET_REDIRECT_URL", null);
                  } else {
                    router.push("/explore");
                  }
                })
                .catch(error => {
                  console.log("Error getting user data", error);
                });
            }
          });
      })
      .catch(error => {
        console.log("Firebase Auth Error:", error);
        state.commit("AUTH_ERROR", error.code);
        state.commit("SET_LOGGED_IN", false);
        state.commit("SET_LOGGED_IN_LOADING", false);
      });
  },
  loggedIn: (state, item) => {
    state.commit("LOGGED_IN", item);
  },
  resendEmailVerification: (state, item) => {
    firebaseInstance.auth().currentUser.sendEmailVerification().then(() => {
      console.log('resent verification email')
    }).catch((error) => {
      console.log('error resending verification email 1', error)
    })
  },
  forgotPassword: (state, item) => {
    var auth = firebase.auth();
    auth
      .sendPasswordResetEmail(item.email)
      .then(() => {
        console.log("sent recovery email");
        state.commit("AFTER_EMAIL_RECOVERY", {});
      })
      .catch(error => {
        console.log("error sending recovery email", error);
        state.commit("AFTER_EMAIL_RECOVERY", {});
      });
  },
  forgotPassword2: (state, item) => {
    var _data = {
      email: item.email,
      url: item.url
    };

    axios
      .post("/resetpassword", {
        params: {
          format: "json",
          data: _data
        }
      })
      .then(function(response) {
        console.log("RESPONSE 1", response);
        state.commit("AFTER_EMAIL_RECOVERY", {});
      })
      .catch(function(error) {
        console.log("ERROR 1", error.response);
        state.commit("AFTER_EMAIL_RECOVERY", {});
      })
      .then(function() {
        // always executed
      });

    // var auth = firebase.auth()
    // auth.sendPasswordResetEmail(item.email).then(() => {
    //   console.log('sent recovery email')
    //   state.commit('AFTER_EMAIL_RECOVERY', {})
    // }).catch((error) => {
    //   console.log('error sending recovery email', error)
    //   state.commit('AFTER_EMAIL_RECOVERY', {})
    // })
  },
  resetPasswordComplete: (state, item) => {
    var auth = firebase.auth();
    auth
      .verifyPasswordResetCode(item.code)
      .then(() => {
        auth
          .confirmPasswordReset(item.code, item.newPassword)
          .then(() => {
            state.commit("SET_AUTH_ERROR", {
              message:
                "You have changed the password successfully. Login with your new password."
            });
            router.push("/login");
          })
          .catch(error => {
            console.log("unable to change password");
          });
      })
      .catch(error => {
        state.commit("SET_AUTH_ERROR", {
          message: "Invalid Code"
        });
      });
  },
  register: (state, item) => {
    var register = firebaseInstance
      .auth()
      .createUserWithEmailAndPassword(item.email, item.password);
    const _url = item.url;
    register
      .then(snap => {
        console.log("registered", snap);
        var data = snap.user;

        var key = Math.ceil(Math.random() * 1000000000);
        var companyKey = "";
        var chars =
          "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
        for (var i = 32; i > 0; --i)
          companyKey += chars[Math.floor(Math.random() * chars.length)];

        var object = {
          fullName: item.fullName,
          email: item.email,
          emailVerified: false,
          verificationKey: key,
          url: item.url,
          company: "My Company",
          myCompany: companyKey
        };

        var companyObject = {
          name: "My Company",
          website: "www.mycompany.com",
          type: "Digital Agency",
          rate: "150",
          cost: "50",
          contingency: "10",
          image: "",
          companyTasks: [
            {
              hourlyRateOverride: "50",
              name: "Design",
              taskType: "hourlyElements",
              useDefaultTask: false,
              useTaskRate: true
            },
            {
              name: "Development",
              taskType: "hourlyElements",
              useDefaultTask: false
            },
            {
              hourlyRateOverride: "10",
              name: "Testing",
              taskType: "percentTasks",
              useDefaultTask: false
            }
          ]
        };

        firebaseInstance
          .database()
          .ref("users/" + data.uid)
          .set(object, () => {
            console.log("saved user data");
            state.commit("SAVE_USER_DATA", object);
            var user = firebaseInstance.auth().currentUser;

            // var actionCodeSettings = {
            //   url: 'https://app.hourprice.com/projects'
            //   // url: 'https://hourprice.firebaseapp.com/verifyEmail/' + key
            // }

            var _data = {
              key: key,
              url: _url,
              email: user.email
            };

            // sendEmailVerification(_data)

            axios
              .post("/sendwelcomeemail", {
                params: {
                  format: "json",
                  data: _data
                }
              })
              .then(function(response) {
                console.log("RESPONSE 1", response);
              })
              .catch(function(error) {
                console.log("ERROR 1", error.response);
              })
              .then(function() {
                // always executed
              });
              firebaseInstance.auth().currentUser.sendEmailVerification().then(() => {
                console.log('sent verification email')
              }).catch((error) => {
                console.log('error resending verification email 1', error)
              })
              if (state.getters.redirectUrl) {
                router.push(state.getters.redirectUrl);
                state.commit("SET_REDIRECT_URL", null);
              } else {
                router.push("/explore");
              }    
          })
          .catch(error => {
            console.log("Error getting user data", error);
          });
      })
      .catch(error => {
        console.log("Error registering account", error);
        state.commit("AUTH_ERROR", error.code);
      });
  },
  updatePassword: (state, item) => {
    return new Promise((resolve, reject) => {
      console.log("update password");
      var user = firebaseInstance.auth().currentUser;
      var credential = firebase.auth.EmailAuthProvider.credential(
        firebase.auth().currentUser.email,
        item.currentPassword
      );

      user
        .reauthenticateAndRetrieveDataWithCredential(credential)
        .then(() => {
          console.log("reauthenticated");
          user.updatePassword(item.newPassword).then(
            response => {
              console.log("password updated");
              resolve(response);
            },
            error => {
              console.log("error updating password", error);
              reject(error);
            }
          );
        })
        .catch(error => {
          console.log("not reauthenticated, error:", error);
          reject(error);
        });
    });
  },
  verifyKey: (state, item) => {
    console.log("verifying key action", item);
    firebaseInstance
      .database()
      .ref("users/" + item.uid + "/verificationKey")
      .once("value", snap => {
        var testKey = snap.val();
        console.log("keys", testKey, item.key);
        // state.commit('SAVE_USER_DATA', data)
        router.push("/explore");
      })
      .catch(error => {
        console.log("Error getting user data", error);
      });
  },
  login: (state, item) => {
    var signIn = firebaseInstance
      .auth()
      .signInWithEmailAndPassword(item.email, item.password);
    signIn
      .then(data => {
        console.log("Firebase Authorized", data);
        state.commit("CLEAR_AUTH_ERROR", {});
        if (state.getters.redirectUrl) {
          router.push(state.getters.redirectUrl);
          state.commit("SET_REDIRECT_URL", null);
        } else {
          router.push("/explore");
        }
        state.commit("SET_LOGGED_IN", true);
        state.commit("SET_LOGGED_IN_LOADING", false);

      })
      .catch(error => {
        console.log("Firebase Auth Error:", error);
        state.commit("AUTH_ERROR", error.code);
        state.commit("SET_LOGGED_IN", false);
        state.commit("SET_LOGGED_IN_LOADING", false);
      });
  },
  clearAuthError: (state, item) => {
    state.commit("CLEAR_AUTH_ERROR", {});
    state.commit("CLEAR_STATE", {});
  },
  setAuthError: (state, item) => {
    state.commit("SET_AUTH_ERROR", {
      message: item.message
    });
  },
  getUserData: (state, item) => {
    return new Promise((resolve, reject) => {
      firebaseInstance
        .database()
        .ref("users/" + item.uid)
        .once("value", snap => {
          var data = snap.val();
          state.commit("SAVE_USER_DATA", {
            ...data,
            ...firebaseInstance.auth().currentUser
          });
          resolve();
        })
        .catch(error => {
          console.log("Error getting user data", error);
        });
    });
  },
  setRedirectUrl: (state, item) => {
    state.commit("SET_REDIRECT_URL", item);
  }
};
